module.exports = __webpack_public_path__ + "images/zeeuwse_small4e4bf15524708045df8319bd1b28262e.png";